import http from '@/http';

const productService = {
  // Lấy danh sách sản phẩm
  getProducts(params = {}) {
    return http.get('/products', { params });
  }
};

export default productService;
